import React, {Component} from 'react';
import {Button} from "react-bootstrap";
import isNumeric from 'validator/lib/isNumeric';
import SpinnerLoader from '../../../../../components/Loader/Spinner';
import _ from 'lodash'
import {Checkbox, Input} from "antd";
import {cloneNewSubpackage} from "../../../LeadManageActions";

const styles = {
  wrapper: {
    width: '100%',
    fontFamily: "'Manrope', sans-serif",
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },
  body: {
    flex: 1,
    padding: '12px 24px 24px 24px',
    overflowY: 'auto',
  },
  sectionTitle: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#55607e',
    marginBottom: '12px',
    marginTop: '4px',
  },
  proposedCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: 'transparent',
  },
  proposedName: { fontSize: '14px', fontWeight: '500', color: '#1a1a2e', flex: '0 0 25%' },
  proposedPrice: { fontSize: '14px', color: '#374151', flex: '0 0 20%' },
  proposedMenu: { fontSize: '13px', color: '#6b7280', flex: 1 },
  addProposedBtn: {
    backgroundColor: '#ffffff',
    border: '1.5px solid #2563eb',
    color: '#2563eb',
    borderRadius: '6px',
    width: '32px',
    height: '32px',
    fontSize: '20px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    lineHeight: 1,
    flexShrink: 0,
  },
  divider: {
    height: '1px',
    backgroundColor: '#e8e8e8',
    margin: '12px 0',
  },
  row: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
  },
  fieldGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  label: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#55607e',
    marginBottom: '6px',
  },
  menuSectionTitle: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.08em',
    color: '#55607e',
    marginBottom: '12px',
    marginTop: '8px',
  },
  menuGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    marginBottom: '16px',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '6px 0',
    borderBottom: '1px solid #f0f0f0',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
  },
  menuItemLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: '#374151',
  },
  counterBox: {
    border: '1px solid #D6D6D6',
    borderRadius: '3px',
    fontSize: '12px',
    display: 'flex',
    lineHeight: '1.7',
  },
  counterBtn: { padding: '0px 7px', color: '#2563eb', cursor: 'pointer' },
  counterVal: { padding: '0px 7px', backgroundColor: '#f8f8f8' },
  addItemBtn: {
    border: '1px solid #D6D6D6',
    borderRadius: '3px',
    color: '#737373',
    fontSize: '12px',
    display: 'flex',
    lineHeight: '1.7',
    cursor: 'pointer',
  },
  footer: {
    paddingTop: '16px',
    borderTop: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  saveBtn: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    padding: '0 28px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    height: '42px',
    minWidth: '110px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

class AddPackage extends Component {
  constructor(props) {
    super(props);
    this.state = { package: {}, menu: [] };
  }

  componentDidMount() {
    this.setState({
      package: {...this.props.package},
      menu: [...this.props.menu]
    }, () => { this.handlePrapareMenu(this.state.menu); });
  }

  componentDidUpdate(prevProps) {
    if(!_.isEqual(this.props, prevProps)) {
      let menu = this.props.menu ? [...this.props.menu] : [];
      this.setState({ package: this.props.package, menu: menu }, () => { this.handlePrapareMenu(menu); });
    }
  }

  handlePrapareMenu = (menu) => {
    const newMenu = menu.map(item => {
      const newItem = { ...item };
      if (newItem.count && newItem.count > 0) { newItem.isSelected = true; newItem.count = newItem.count; }
      else { newItem.isSelected = false; newItem.count = 0; }
      return newItem;
    });
    this.setState({ menu: newMenu });
  };

  handleMethodOfContactChange = () => {};

  checkPackageValidation = (pack) => {
    let isValid = true;
    if(!!!pack.name || pack.name === '') { isValid = false; this.props.showMessage('Please Provide Package Name.', 'warning'); }
    else if(!!!pack.package_price || pack.package_price === '') { isValid = false; this.props.showMessage('Please Provide Package price', 'warning'); }
    else if(!isNumeric(pack.package_price?.toString())) { isValid = false; this.props.showMessage('Please Enter Numeric Package price', 'warning'); }
    return isValid;
  };

  handleAddPackage = () => {
    try {
      const newPackage = { ...this.state.package };
      newPackage.menuItems = this.state.menu.filter(item => item.isSelected === true).map(item => {
        const menu = { ...item }; menu.count = item.count; menu.menuId = item._id; return menu;
      });
      newPackage.eventId = this.props.eventId;
      newPackage.venueId = this.props.venueId;
      newPackage.isCreatedByVenue = true;
      newPackage.isCreatedByAdmin = false;
      if (this.checkPackageValidation(newPackage)) {
        this.props.addPackage(newPackage);
        this.props.handleCloseAddPackageOverlay();
      }
    } catch (e) { console.log(e); }
  };

  handleIncrementMenuItem = (id) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        if (newItem.count === 0) { newItem.isSelected = true; }
        if (newItem.count) {
          if (newItem.count < newItem.count) { newItem.count = newItem.count + 1; }
          else { this.props.showMessage('Max count reached', 'warning'); }
        } else { newItem.count = newItem.count + 1; }
        return newItem;
      }
      return item;
    });
    this.setState({ menu: menu });
  };

  handleDecrementMenuItem = (id) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        if (newItem.count > 0) { newItem.count = newItem.count - 1; }
        if (newItem.count === 0) { newItem.isSelected = false; }
        return newItem;
      }
      return item;
    });
    this.setState({ menu: menu });
  };

  handleSelectMenuItem = (id, value) => {
    const menu = this.state.menu.map(item => {
      if (item._id === id) {
        const newItem = { ...item };
        newItem.isSelected = !value;
        if (newItem.isSelected) { newItem.count = 1; } else { newItem.count = 0; }
        return newItem;
      }
      return item;
    });
    this.setState({ menu: menu });
  };

  handleAddProposedPackage = (proposedPackage) => {
    if (this.checkPackageValidation(proposedPackage)) {
      if(this?.props?.lead?._id && this.props.lead.event && this.props.venueId && proposedPackage._id) {
        this.props.dispatch(cloneNewSubpackage(this.props.lead._id, this.props.lead.event, this.props.venueId, proposedPackage._id, proposedPackage));
      }
    }
  };

  render() {
    let staticContent = this.props.staticContent;
    let packages = this.props.packages;

    return (
      <div style={styles.wrapper}>
        <div className="custom-drawer-header">
            <span className="custom-drawer-title">
                {staticContent.PACKAGE_PAGE_PACKAGE_ADD_CUSTOM_PACKAGE || 'Add Package'}
            </span>
            <button className="custom-drawer-close-btn" onClick={this.props.handleCloseAddPackageOverlay}>✕</button>
        </div>
        <div style={styles.body}>

          {/* Proposed Packages */}
          {packages && packages.length > 0 && (
            <>
              <div style={styles.sectionTitle}>{staticContent?.PACKAGE_PAGE_PROPOSED_PACKAGES}</div>
              {packages.map(item => (
                <div key={item._id} style={styles.proposedCard}>
                  <span style={styles.proposedName}>{item.name && _.startCase(item.name)}</span>
                  <span style={styles.proposedPrice}>{item.package_price}</span>
                  <span style={styles.proposedMenu}>
                    {item.menuItems.map((menuItem, index) => (
                      <span key={index}>
                        <span style={{ marginRight: '4px' }}>{menuItem?.name}</span>
                        <span style={{ marginRight: '8px', fontWeight: 500, color: '#374151' }}>{menuItem?.count}</span>
                      </span>
                    ))}
                  </span>
                  <button style={styles.addProposedBtn} onClick={() => this.handleAddProposedPackage(item)}>+</button>
                </div>
              ))}
              <div style={styles.divider} />
            </>
          )}

          {/* Custom Package */}
          <div style={styles.sectionTitle}>{staticContent.PACKAGE_PAGE_PACKAGE_ADD_CUSTOM_PACKAGE}</div>
          <div style={styles.row}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>{staticContent.PACKAGE_PAGE_PACKAGE_NAME_LABEL || 'Package Name'}</label>
              <Input
                style={{ height: '44px', borderRadius: '8px' }}
                onChange={(e) => { let p = {...this.state.package}; p.name = e.target.value; this.setState({ package: p }); }}
                ref={(ref) => this.packageName = ref}
                placeholder={staticContent.PACKAGE_PAGE_PACKAGE_NAME_LABEL || 'Package Name'}
                value={this?.state?.package?.name || ''}
              />
            </div>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>{staticContent.PACKAGE_PAGE_PACKAGE_PRICE_LABEL}</label>
              <Input
                style={{ height: '44px', borderRadius: '8px' }}
                min={0}
                type={'number'}
                onChange={(e) => { let p = {...this.state.package}; p.package_price = e.target.value; this.setState({ package: p }); }}
                placeholder={staticContent.PACKAGE_PAGE_PACKAGE_PRICE_LABEL}
                value={this.state.package ? this.state.package.package_price : ''}
              />
            </div>
          </div>

          {/* Menu Items */}
          {/* <div style={styles.menuSectionTitle}>{staticContent.PACKAGE_PAGE_PACKAGE_MENU_TITLE}</div>
          <div style={styles.menuGrid}>
            {this.state.menu && this.state.menu.length > 0 && this.state.menu.map(item => (
              <div key={item._id} style={styles.menuItem}>
                <div style={styles.menuItemLeft}>
                  <Checkbox checked={item.isSelected && item.isSelected} onChange={() => this.handleSelectMenuItem(item._id, item.isSelected)} />
                  <span>{item.name}</span>
                </div>
                {item.isSelected && item.count > 0 ? (
                  <span style={styles.counterBox}>
                    <span style={styles.counterBtn} onClick={() => this.handleDecrementMenuItem(item._id)}>-</span>
                    <span style={styles.counterVal}>{item.count}</span>
                    <span style={styles.counterBtn} onClick={() => this.handleIncrementMenuItem(item._id)}>+</span>
                  </span>
                ) : null}
                {item.count === 0 ? (
                  <span onClick={() => this.handleIncrementMenuItem(item._id)} style={styles.addItemBtn}>
                    <span style={{ padding: '0px 7px', marginRight: '3px' }}>Add</span>
                    <span style={{ padding: '0px 7px', color: '#2563eb' }}>+</span>
                  </span>
                ) : null}
              </div>
            ))}
          </div> */}

        </div>

        {/* Footer */}
        <div className="custom-drawer-footer">
          <button
            className="btn-secondary-custom"
            onClick={this.props.handleCloseAddPackageOverlay}
            type="button"
          >
            Cancel
          </button>
          <button
            disabled={this.props.isAddingSubPackage}
            className="btn-primary-custom"
            onClick={() => this.handleAddPackage(this.state.package)}
            type="button"
          >
            {this.props.isAddingSubPackage ? <SpinnerLoader /> : (staticContent.PACKAGE_PAGE_PACKAGE_SAVE_BUTTON_TEXT || 'Save')}
          </button>
        </div>
      </div>
    );
  }
}

export default AddPackage;